export default function BenefitsSection() {
  const benefits = [
    {
      title: 'Codzienne Aktualizacje',
      desc: 'Nasza baza arkuszy USFans jest aktualizowana każdego dnia, dzięki czemu zawsze masz dostęp do najświeższych rankingów i danych.',
      icon: 'ri-refresh-line',
      img: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20desk%20with%20laptop%20displaying%20dashboard%20charts%20and%20spreadsheet%20data%2C%20warm%20natural%20sunlight%20from%20window%2C%20clean%20desk%20with%20white%20ceramic%20coffee%20mug%2C%20professional%20yet%20cozy%20atmosphere%2C%20soft%20cream%20and%20sand%20tones%2C%20editorial%20interior%20photography&width=800&height=600&seq=usfans-benefit-daily-c1&orientation=landscape',
    },
    {
      title: 'Pełne Bezpieczeństwo',
      desc: 'Weryfikujemy każde źródło informacji o USFans Spreadsheet. Nie przechowujemy żadnych danych użytkowników — Twoja prywatność jest dla nas priorytetem.',
      icon: 'ri-shield-check-line',
      img: 'https://readdy.ai/api/search-image?query=Transparent%20frosted%20glass%20security%20shield%20hovering%20over%20abstract%20data%20pattern%20on%20warm%20cream%20minimalist%20background%2C%20soft%20diffused%20lighting%2C%20modern%20tech%20safety%20concept%2C%20clean%20design%20aesthetic%2C%20warm%20neutral%20palette&width=800&height=600&seq=usfans-benefit-safety-d2&orientation=landscape',
    },
    {
      title: 'Eksperckie Przewodniki',
      desc: 'Nasz zespół ekspertów przygotowuje szczegółowe poradniki i analizy, które pomogą Ci zrozumieć każdy aspekt arkuszy USFans.',
      icon: 'ri-award-line',
      img: 'https://readdy.ai/api/search-image?query=Diverse%20professional%20team%20collaborating%20around%20large%20display%20screen%20in%20bright%20modern%20office%2C%20warm%20ambient%20lighting%2C%20cream%20walls%20with%20wooden%20furniture%2C%20positive%20engaging%20workplace%20atmosphere%2C%20editorial%20corporate%20photography%2C%20natural%20color%20palette&width=800&height=600&seq=usfans-benefit-experts-e3&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-12 gap-4">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            Dlaczego USFans Spreadsheet?
            <span className="block text-accent-500">Dlaczego warto?</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-md">
            Poznaj kluczowe zalety największej bazy arkuszy USFans w Polsce
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {benefits.map((benefit, idx) => (
            <div key={idx} className="bg-background-50 rounded-2xl overflow-hidden group cursor-pointer transition-all hover:scale-[1.02]">
              <div className="relative h-52 overflow-hidden">
                <img
                  src={benefit.img}
                  alt={benefit.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4 w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center shadow-sm">
                  <i className={`${benefit.icon} text-lg text-accent-500`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{benefit.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{benefit.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}